import { useSelector } from 'react-redux';

import ButtonCalendar from 'atoms/button-calendar';
import { getDayFromDate, getTimeFromDate } from 'util';

export function MobileView() {
  const { provider, service, dateStart } =
    useSelector((state) => state.requestAppointmentForm) || {};
  const time = getTimeFromDate(dateStart);
  const formattedTime = time.split(':');

  if (!provider || !service) return;

  return (
    <div className="w-100 p-15 pb-40 flex-column justify-between h-100-mobile align-center">
      <h1>Your appointment has been confirmed</h1>
      <p className="text-grey-dark mt-10 mb-10">
        As a reminder, if you must cancel please do so more than 24 hours before
        your appointment time to avoid a cancellation fee. You can manage your
        appointment and future pet care needs in the PawCare mobile app.
      </p>
      <div className="flex-column mt-30">
        <ButtonCalendar
          title={`${provider.name} - ${service.name}`}
          startDate={getDayFromDate(dateStart)}
          duration={service.durationMinutes}
          startTime={formattedTime}
          location={`${provider.address1}, ${provider.postalCode} ${provider.locality}, ${provider.region}`}
        />
        <a
          className="download-app-button button--round flex-row button mt-10"
          href="https://www.mypawcare.com/link"
          target="_blank"
          rel="noreferrer"
        >
          Download the app
        </a>
      </div>
    </div>
  );
}
